export enum ButtonTarget {
  InApp = "in_app",
  BrowserExternal = "browser-external",
  BrowserInternal = "browser-internal",
}

export enum CtaType {
  Network = "network",
  Renewal = "renewal",
  Subscribe = "subscribe",
}

export interface CustomCta {
  id: number;
  title: string;
  text: string;
  button_text: string;
  button_action: string;
  button_target: ButtonTarget;
}
